import { BookType, Sparkles } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';

interface NarrativeTechniqueCardProps {
  technique: {
    technique: string;
    description: string;
    ref?: string;
  };
}

export function NarrativeTechniqueCard({
  technique
}: NarrativeTechniqueCardProps) {
  return (
    <DiscoveryCard
      isExpanded={true}
      onToggle={() => { }}
      canExpand={false}
      icon={BookType}
      header={
        <div className="flex flex-col gap-3 flex-1 min-w-0 relative z-10">
          <div className="flex items-center justify-between gap-2">
            <h4 className="text-xl font-serif font-medium tracking-tight text-foreground/90 leading-tight">
              {technique.technique}
            </h4>
            {technique.ref && (
              <span className="text-xs font-medium text-muted-foreground bg-muted/50 px-2 py-0.5 rounded-full">
                {technique.ref}
              </span>
            )}
          </div>
        </div>
      }
    >
      <div className="space-y-4 relative z-10 px-1">
        <p className="text-sm text-foreground/70 font-light leading-relaxed italic">
          {technique.description}
        </p>
      </div>
    </DiscoveryCard>
  );
}
